<template>
  <div class="specs">
    <div class="corpoDocumentacao">
      <div class="title">
        <h1>Histórico</h1>
        <hr />
      </div>
      <div>
        <table class="table table-striped entrada">
          <thead>
            <tr>
              <th class="item-historico item-historico-versao">Data</th>
              <th class="item-historico item-historico-versao">Versão</th>
              <th class="item-historico">Detalhe</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in historico">
              <td
               
                class="item-historico item-historico-versao"
              >
                <span v-text="item.data"></span>
              </td>
              <td class="item-historico item-historico-versao">
                <span v-text="item.versao"></span>
              </td>

              <td class="item-historico item-hitorico-detalhe">
                <span style="width: auto" v-text="item.detalhe"></span>
              </td>
              <td
                class="item-historico item-historico-versao"
                style=" border-bottom-width: 0px"
              >
                <button @click="abrirModalComDados(item)" title="ver datelhes">
                  <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-detalhe">
      <ModalHistoricoComponent
        :show="showModal"
        @close="closeModal"
        :dadosModal="dadosModal"
      ></ModalHistoricoComponent>
    </div>
  </div>
</template>

<script>
import ModalHistoricoComponent from "./ModalHistorico.vue";
import * as alertUtils from "@/utils/alert";
import * as loaderUtils from "@/utils/loader";

export default {
  name: "Historico",
  props: {
    grupo: String,
    nome: String,
    idServicoApi: String,
    segmentacao: String,
    dadosApiCatalogo: Object,
  },
  data() {
    return {
      historico: [],
      dadosModal: {},
      showModal: false,
    };
  },
  components: {
    ModalHistoricoComponent,
  },
  methods: {
    // Defina seus métodos aqui
    carregarDados() {
      this.historico = this.dadosApiCatalogo.historico;
      if (this.historico != null) {
        this.historico = this.historico.reverse();
      }
    },
    abrirModalComDados(subItem) {
      this.dadosModal = {
        versao: subItem.versao,
        detalhe: subItem.detalhe,
        itens: subItem.itens,
      };
      if ( this.dadosModal && this.dadosModal.itens && this.dadosModal.itens.length > 0 ) {
        this.showModal = true;
      } else {
        alertUtils.alertError("Não há ítens disponiveis no histórico.");
        loaderUtils.removeLoader();
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>
<style scoped>
@import "/massificados/corporativo/gerenciador-parceiros-ui/historico/css/style.css";
</style>
